import SvgLogo from "./PodtracLogo.svg";

export function PodtracLogo(props) {
    return <SvgLogo className="podtrac-logo" alt="Podtrac" {...props} />;
}

export function PodtracLogoCropped(props) {
    return (
        <SvgLogo
            className="podtrac-logo cropped"
            alt="Podtrac"
            {...props}
            viewBox="100 0 270 259.65"
        />
    );
}
